// Product Recommendations Slider - Similar to Collection Product Slider
document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.ProductRecommendationsSlider');
    if (!section) {
        return;
    }
 
    const wrapper = section.querySelector('.ProductRecommendationsSlider__Wrapper');
    
    if (!wrapper) {
        return;
    }

    function updateProgressBar(swiper) {
        if (!swiper) return;
        
        const progressBar = wrapper.querySelector('.ProductRecommendationsSlider__ProgressBar');
        if (!progressBar) return;

        // Get Swiper's progress (0 at start, 1 at end)
        let progress = swiper.progress || 0;
        progress = Math.max(0, Math.min(1, progress));

        // Calculate minimum width based on visible slides / total slides
        const totalSlides = swiper.slides ? swiper.slides.length : 0;

        // Get current slidesPerView based on window width and breakpoints
        let slidesPerView = swiper.params.slidesPerView || 1;

        // Check breakpoints to get the correct slidesPerView for current screen size
        if (swiper.params.breakpoints) {
            const currentWidth = window.innerWidth;
            const breakpoints = Object.keys(swiper.params.breakpoints)
                .map(bp => parseInt(bp))
                .sort((a, b) => b - a); // Sort descending

            // Find the matching breakpoint
            for (let bp of breakpoints) {
                if (currentWidth >= bp) {
                    const config = swiper.params.breakpoints[bp];
                    if (config && typeof config.slidesPerView === 'number') {
                        slidesPerView = config.slidesPerView;
                        break;
                    }
                }
            }
        }

        // Minimum progress = visible slides / total slides
        const minProgress = totalSlides > 0 ? Math.min(1, slidesPerView / totalSlides) : 0;

        // Map progress from [0,1] to [minProgress, 1]
        // When progress = 0, width = minProgress
        // When progress = 1, width = 1 (100%)
        const mappedProgress = minProgress + (progress * (1 - minProgress));

        // Set the progress bar width
        progressBar.style.width = (mappedProgress * 100) + '%';
    }

    function initCardSwipers(parentEl) {
        // Initialize swipers inside cards
        const cardSwipers = parentEl.querySelectorAll('.CollectionSliderCard__InnerSlider');
        cardSwipers.forEach(cs => {
             if(cs.swiper) return;
             const paginationEl = cs.querySelector('.CollectionSliderCard__Pagination');
             const swiperInstance = new Swiper(cs, {
                 nested: true,
                 allowTouchMove: true,
                 observer: true,
                 observeParents: true,
                 effect: 'fade',  
                 fadeEffect: { crossFade: true },
                 pagination: {
                     el: paginationEl,
                     type: 'bullets',
                     clickable: true
                 },
                 autoplay: {
                     delay: 2000,
                     disableOnInteraction: false,
                     pauseOnMouseEnter: false,
                     stopOnLastSlide: false
                 }
             }); 
             if(swiperInstance.autoplay) {
                 swiperInstance.autoplay.stop();
             }
        }); 
    }

    function initSwipers() {
        if (typeof Swiper === 'undefined') {
            console.warn('Swiper not loaded yet, retrying in 100ms');
            setTimeout(initSwipers, 100);
            return;
        }

        const swiperContainer = wrapper.querySelector('.swiper-container');
        if (!swiperContainer) return;
        
        if (swiperContainer.swiper) return;

        const nextEl = wrapper.querySelector('.swiper-button-next');
        const prevEl = wrapper.querySelector('.swiper-button-prev');

        const isMobile = window.innerWidth <= 768;
         
        if (!wrapper.dataset.currentIndex) {
            wrapper.dataset.currentIndex = '0';
        }
         
        function handleMobileNavigation(direction) {
            const checkMobile = window.innerWidth <= 768;
            if (!checkMobile) return;
            
            const visibleSlides = Array.from(wrapper.querySelectorAll('.ProductRecommendationsSlider__Slide'));
            const totalSlides = visibleSlides.length;
            const slidesPerPage = 2; // Mobile shows 2 products per page
            const maxIndex = Math.max(0, Math.ceil(totalSlides / slidesPerPage) - 1);
            
            let currentIndex = parseInt(wrapper.dataset.currentIndex || '0', 10);
            
            if (direction === 'next') {
                currentIndex = Math.min(currentIndex + 1, maxIndex);
            } else if (direction === 'prev') {
                currentIndex = Math.max(currentIndex - 1, 0);
            } else if (direction === 'init') {
                currentIndex = 0;
            }
            
            wrapper.dataset.currentIndex = currentIndex.toString();
            
            const wrapperEl = swiperContainer.querySelector('.swiper-wrapper');
            
            const startIdx = currentIndex * slidesPerPage;
            const endIdx = Math.min(startIdx + slidesPerPage, visibleSlides.length);
            
            visibleSlides.forEach((slide, index) => {
                if (index >= startIdx && index < endIdx) {
                    slide.style.display = 'block';
                    slide.style.opacity = '1';
                    slide.style.visibility = 'visible';
                    slide.classList.remove('mobile-hidden');
                } else {
                    slide.style.display = 'none';
                    slide.style.opacity = '0';
                    slide.style.visibility = 'hidden';
                    slide.classList.add('mobile-hidden');
                }
            });
            
            if (wrapperEl) {
                wrapperEl.style.display = 'grid';
            }
            
            const progress = totalSlides > slidesPerPage ? (currentIndex + 1) / (maxIndex + 1) : 1;
            const progressBar = wrapper.querySelector('.ProductRecommendationsSlider__ProgressBar');
            if (progressBar) {
                progressBar.style.width = (progress * 100) + '%';
            }
            
            if (prevEl) {
                prevEl.classList.toggle('swiper-button-disabled', currentIndex === 0);
            }
            if (nextEl) {
                nextEl.classList.toggle('swiper-button-disabled', currentIndex >= maxIndex);
            }
        }
        
        // Add click handler for progress bar on mobile
        function handleProgressBarClick(e) {
            const checkMobile = window.innerWidth <= 768;
            if (!checkMobile) return;
            
            const visibleSlides = Array.from(wrapper.querySelectorAll('.ProductRecommendationsSlider__Slide'));
            const totalSlides = visibleSlides.length;
            const slidesPerPage = 2;
            const maxIndex = Math.max(0, Math.ceil(totalSlides / slidesPerPage) - 1);
            
            if (maxIndex === 0) return; // No need to navigate if only one page
            
            const progressBarContainer = wrapper.querySelector('.ProductRecommendationsSlider__ProgressBarContainer');
            if (!progressBarContainer) return;
            
            const rect = progressBarContainer.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const percentage = Math.max(0, Math.min(1, clickX / rect.width));
            
            // Calculate which page to navigate to based on click position
            const targetIndex = Math.min(maxIndex, Math.floor(percentage * (maxIndex + 1)));
            
            // Update to the target index
            wrapper.dataset.currentIndex = targetIndex.toString();
            
            const startIdx = targetIndex * slidesPerPage;
            const endIdx = Math.min(startIdx + slidesPerPage, visibleSlides.length);
            
            visibleSlides.forEach((slide, index) => {
                if (index >= startIdx && index < endIdx) {
                    slide.style.display = 'block';
                    slide.style.opacity = '1';
                    slide.style.visibility = 'visible';
                    slide.classList.remove('mobile-hidden');
                } else {
                    slide.style.display = 'none';
                    slide.style.opacity = '0';
                    slide.style.visibility = 'hidden';
                    slide.classList.add('mobile-hidden');
                }
            });
            
            const progress = totalSlides > slidesPerPage ? (targetIndex + 1) / (maxIndex + 1) : 1;
            const progressBar = wrapper.querySelector('.ProductRecommendationsSlider__ProgressBar');
            if (progressBar) {
                progressBar.style.width = (progress * 100) + '%';
            }
            
            if (prevEl) {
                prevEl.classList.toggle('swiper-button-disabled', targetIndex === 0);
            }
            if (nextEl) {
                nextEl.classList.toggle('swiper-button-disabled', targetIndex >= maxIndex);
            }
        }
        
        const swiper = new Swiper(swiperContainer, {
            slidesPerView: isMobile ? 2 : 4,
            spaceBetween: isMobile ? 15 : 22,
            observer: true,
            observeParents: true,
            watchSlidesProgress: true,
            slidesPerGroup: isMobile ? 2 : 1,
            allowTouchMove: !isMobile, 
            navigation: isMobile ? false : {
                nextEl: nextEl,
                prevEl: prevEl,
            },
            breakpoints: {
                0: { 
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 15,
                    allowTouchMove: false
                },
                769: { 
                    slidesPerView: 3.2,
                    slidesPerGroup: 1,
                    spaceBetween: 22,
                    allowTouchMove: true
                },
                1200: { 
                    slidesPerView: 3.2,
                    slidesPerGroup: 1,
                    spaceBetween: 22
                }
            },
            on: {
                progress: function(s) {
                    if (!isMobile) updateProgressBar(s);
                },
                setTransition: function(s, duration) {
                    if (!isMobile) {
                        const progressBar = wrapper.querySelector('.ProductRecommendationsSlider__ProgressBar');
                        if (progressBar) progressBar.style.transitionDuration = duration + 'ms';
                    }
                },
                init: function(s) {
                    initCardSwipers(s.el);
                    if (isMobile) { 
                        handleMobileNavigation('init');
                    }
                }
            }
        });
         
        if (nextEl && prevEl) { 
            const newNextHandler = (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (window.innerWidth <= 768) {
                    handleMobileNavigation('next');
                }
            };
            
            const newPrevHandler = (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (window.innerWidth <= 768) {
                    handleMobileNavigation('prev');
                }
            };
            
            nextEl.removeEventListener('click', newNextHandler);
            prevEl.removeEventListener('click', newPrevHandler);
            
            nextEl.addEventListener('click', newNextHandler, { passive: false });
            prevEl.addEventListener('click', newPrevHandler, { passive: false });
        }
        
        // Add progress bar click handler for mobile
        const progressBarContainer = wrapper.querySelector('.ProductRecommendationsSlider__ProgressBarContainer');
        if (progressBarContainer) {
            progressBarContainer.addEventListener('click', handleProgressBarClick);
        }
         
        if (!isMobile) {
            updateProgressBar(swiper);
        } else {
            const initialVisibleSlides = Array.from(wrapper.querySelectorAll('.ProductRecommendationsSlider__Slide'));
            initialVisibleSlides.forEach((slide, index) => {
                if (index < 2) { // Mobile shows 2 products initially
                    slide.style.display = 'block';
                    slide.style.opacity = '1';
                    slide.style.visibility = 'visible';
                    slide.classList.remove('mobile-hidden');
                } else {
                    slide.style.display = 'none';
                    slide.style.opacity = '0';
                    slide.style.visibility = 'hidden';
                    slide.classList.add('mobile-hidden');
                }
            });
            
            setTimeout(() => {
                handleMobileNavigation('init');
            }, 100);
        }

        bindMouseWheelToSlider(swiper, wrapper);
    }

    function bindMouseWheelToSlider(swiper, sliderWrapper) {
        if (!swiper || !sliderWrapper || typeof window.CPBindHorizontalWheelScroll !== 'function') return;

        window.CPBindHorizontalWheelScroll({
            swiper: swiper,
            wheelTarget: sliderWrapper,
            bindKey: 'wheelBound'
        });
    }

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            const swiperEl = wrapper.querySelector('.swiper-container');
            if (swiperEl && swiperEl.swiper) {
                swiperEl.swiper.update();
                updateProgressBar(swiperEl.swiper);
            }
        }, 250);
    });
 
    initSwipers();
    
});

